'use client';

import { c as _c } from "react/compiler-runtime";
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { icon } from '@/uiPrimitives/media/icon';
import { stack } from '@/uiPrimitives/layout/stack';
import { styledToTopTextBlock, styledToTopButton, styledToTopText, styledToTopWrapper } from './ToTop.css';
import { textBlock } from '@/uiPrimitives/typography/text';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { position } from '@/uiPrimitives/layout/position';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { pageGrid } from '@/uiPrimitives/layout/pageGrid/pageGrid';
import { pageGridItem } from '@/uiPrimitives/layout/pageGrid/pageGridItem';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { translateInline } from '../translate/translateInline';
const text = translateInline({
  en: 'To top',
  nl: 'Naar boven'
});
export const ToTopLink = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classes(pageGridItem({
      gridColumnStart: "span 1",
      justifySelf: "end"
    }), shelf({
      alignItems: "center"
    }), position({
      position: "relative"
    }), box({
      backgroundColor: "positiveBlue",
      padding: "-2 | smaller"
    }), zIndex({
      zIndex: "toTop"
    }), styledToTopButton);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = addTestSelector("uiToTopButton");
    t2 = classes(occupy({
      blockSize: "capSize",
      inlineSize: "capSize"
    }));
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DOPLink href="#" data-link-type="toTop-link" className={t0} aria-label={text} {...t1}><div className={t2} aria-hidden={true}><div className={classes(stack({
          gap: "0px"
        }))}><i className={classes(icon({
            icon: chevronIcon,
            adjustIcon: "rotate90degFlipHorizontal",
            blockSize: "auto",
            inlineSize: "-2 | smaller"
          }))} /><i className={classes(icon({
            icon: chevronIcon,
            adjustIcon: "rotate90degFlipHorizontal",
            blockSize: "auto",
            inlineSize: "-2 | smaller"
          }))} /></div></div><div className={classes(styledToTopTextBlock)}><div className={classes(textBlock({
          textDecorationLine: "none"
        }), box({
          padding: "-2 | smaller"
        }), styledToTopText)}>{text}</div></div></DOPLink>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export const ToTop = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={classes(styledToTopWrapper, unprintable, pageGrid({
      columnCount: "12-of-12"
    }))}><ToTopLink /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};